document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("getprintsize");

  if (!button) return;

  button.addEventListener("click", function () {
    const input = document.getElementById("headcircumference");
    const output = document.getElementById("printsize");

    const result = ((input.value / 22) * 100).toFixed(2);

    output.innerHTML =
      "Your estimated template print size is: " + result + "%";
  });
});